import { render, staticRenderFns } from "./ClassesDetailRecommend.vue?vue&type=template&id=7148fae0&scoped=true&"
import script from "./ClassesDetailRecommend.vue?vue&type=script&lang=js&"
export * from "./ClassesDetailRecommend.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetailRecommend.vue?vue&type=style&index=0&id=7148fae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7148fae0",
  null
  
)

export default component.exports